import { Directive } from '@angular/core';
import { ShowHideDirective } from '@angular/flex-layout';

const selector = `[fxShow.handset.portrait]`;
const inputs = ['fxShow.handset.portrait'];

@Directive({
  selector, 
  inputs
})
export class CustomFxShowHandsetPortraitDirective extends ShowHideDirective {
  protected inputs = inputs;
}
